import { Injectable } from '@angular/core';
import { Firestore, doc, updateDoc } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { Platform, ToastController } from '@ionic/angular/standalone';
import { Observable } from 'rxjs';
// import { FirebaseX } from '@ionic-native/firebase-x/ngx';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {
  constructor(
    public afs: Firestore,
    // public firebase: FirebaseX,
    private platform: Platform,
    private router: Router,
    private toastCtrl: ToastController
  ) {}

  async grantPermission(user: any) {
    if (this.platform.is('cordova')) {
      // if (await this.firebase.hasPermission() == false) {
      //   await this.firebase.grantPermission()
      //   .then((success: any) => {
      //     if (success) {
      //       this.getToken(user);
      //     }
      //   })
      // }
    } else {
      this.getToken(user);
    }
  }
  
  notificationSetup(user: any) {
    this.getToken(user);
    this.onMessageReceived().subscribe(
      (msg: { aps: { alert: { title: string; body: string; }; }; title: string; body: string; }) => {
        if (this.platform.is('ios')) {
          this.presentToast(msg.aps.alert.title, msg.aps.alert.body);
        } else {
          this.presentToast(msg.title, msg.body);
        }
      }
    )
  }

  async getToken(user: any) {
    let token: any;
    if (this.platform.is('android')) {
      // token = await this.firebase.getToken()
      // .then((token: string) => {
      //   this.saveToken(user,token)
      // })
      // .catch((error: any) => console.error('Error Android token',error));
    } 

    if (this.platform.is('ios')) {
      // token = await this.firebase.getToken()
      // .then((token: string) => {
      //   this.saveToken(user,token)
      // })
      // .catch((error: any) => console.error('Error iOS token',error));
    }
  }

  // save the permission token in firestore
  private saveToken(user: any, token: string): void {
    const currentTokens = user.tokens || {}
    if (!currentTokens[token]) {
      const userRef = doc(this.afs,'ge_users/' + user.uid)
      const tokens = { ...currentTokens, [token]: true }
      updateDoc(userRef, { tokens })
    }
  }

  onMessageReceived(): Observable<any> {
    // return this.firebase.onMessageReceived()
    return new Observable<any>(); // Return empty Observable for now
  }

  async presentToast(title: string, body: string) {
    const toast = await this.toastCtrl.create({
      header: title,
      message: body,
      color: 'success',
      position: 'bottom',
      duration: 2000,
      buttons: [
        {
          side: 'end',
          icon: 'md-open',
          handler: () => {
            this.router.navigate(['/account/messages']);
          }
        }
      ]
    })
    await toast.present();
  }
}